import { render } from "./AINavigation.vue?vue&type=template&id=2cfbfca9&scoped=true"
import script from "./AINavigation.vue?vue&type=script&lang=js"
export * from "./AINavigation.vue?vue&type=script&lang=js"

import "./AINavigation.vue?vue&type=style&index=0&id=2cfbfca9&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cfbfca9"]])

export default __exports__